import { getRoles } from '@dispatch/shared/services';
import { RolesListFilter } from '@dispatch/shared/types';
import { usePaginatedQuery } from '../api/usePaginatedQuery';

export const useGetRoles = (filters?: RolesListFilter, enabled = true) => {
  return usePaginatedQuery(
    ['roles', filters],
    async (token) => getRoles(filters, token),
    {
      enabled,
    }
  );
};
